// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__2NMai","productName":"Table_productName__TNT4b"};